<template>
    <div class="ml-4 mr-4 mt-2" :alvqa="alvqa">
        <BaseButton
            v-if="!preview"
            label="lang_PUBLISHING_USAGE_BUTTON_REDERIVE"
            icon="refresh"
            color="buttonNewEntity"
            :loading="loading"
            :alvqa="alvqa + '-button-check'"
            @click="check"
        />
        <v-alert
            v-else
            :color="preview.changed > 0 ? 'standardBrownIcon' : 'buttonNewEntity'"
            :icon="preview.changed > 0 ? 'warning_amber' : 'check_circle'"
            dense border="left" colored-border
            class="mb-0"
            :alvqa="alvqa + '-preview'"
        >
            <div>{{ $t('lang_PUBLISHING_USAGE_CAPTION_REDERIVE_PREVIEW', {
                changed: $n(preview.changed), parsed: $n(preview.parsed), withIdentifier: $n(preview.withIdentifier)
            }) }}</div>
            <ul v-if="preview.changes.length" class="caption mt-1">
                <li v-for="change in preview.changes.slice(0, shownChanges)" :key="change.raw">
                    {{ change.raw }}: {{ episodeText(change.before, change.after) }} → {{ episodeText(change.after, change.before) }} ({{ $n(change.rows) }})
                </li>
                <li v-if="preview.changed > shownChanges" class="subtitleGray--text">
                    {{ $t('lang_PUBLISHING_USAGE_CAPTION_EXPORT_MORE_ROWS', { shown: $n(Math.min(shownChanges, preview.changes.length)), total: $n(preview.changed) }) }}
                </li>
            </ul>
            <div v-if="preview.comparisonsToRerun && preview.comparisonsToRerun.length" class="caption mt-1">
                {{ $t('lang_PUBLISHING_USAGE_CAPTION_COMPARE_AGAIN_HINT') }}
            </div>
            <div class="mt-2">
                <BaseButton label="lang_GENERAL_BUTTON_CANCEL" color="buttonCancel" class="mr-2" :alvqa="alvqa + '-button-cancel'" @click="preview = null" />
                <BaseButton
                    v-if="preview.changed > 0"
                    label="lang_GENERAL_CONFIRM"
                    :loading="loading"
                    :alvqa="alvqa + '-button-confirm'"
                    @click="run"
                />
            </div>
        </v-alert>
    </div>
</template>

<script>
import BaseButton from '@/components/_buttons/BaseButton'
import usageApi from '@/api/usageApi'
import { usageErrorText } from '@/store/modules/2_publishing/usage'
import { NUMBERINGS, optionText } from '../usageOptions'

/** Reads an imported file's episode values again with the current patterns (Account > Settings): a dry run says how
 *  many rows would change, confirming applies it. */
export default {
    name: 'UsageEpisodeRederive',
    components: { BaseButton },
    props: {
        datasetId: { type: Number, required: true }
    },
    data() {
        return { alvqa: 'publishing-usage-rederive', preview: null, loading: false, shownChanges: 5 }
    },
    methods: {
        // The numbering is named when it is what changes
        episodeText(episode, other) {
            if (!episode) return '–'
            const text = (episode.season !== null ? 'S' + episode.season + ' ' : '') + 'E' + episode.episode
            return other && other.numbering !== episode.numbering ? text + ' (' + this.$t(optionText(NUMBERINGS, episode.numbering)) + ')' : text
        },
        async check() {
            this.loading = true
            const result = await usageApi.rederiveEpisodes(this.datasetId, true)
            this.loading = false
            if (!result.ok) return this.$store.commit('setSnackbar', { type: 'error', msg: usageErrorText(result.error) })
            this.preview = result.data
        },
        async run() {
            this.loading = true
            const result = await usageApi.rederiveEpisodes(this.datasetId, false)
            this.loading = false
            if (!result.ok) return this.$store.commit('setSnackbar', { type: 'error', msg: usageErrorText(result.error) })
            this.preview = null
            this.$store.commit('setSnackbar', { type: 'success', msg: this.$t('lang_PUBLISHING_USAGE_MESSAGE_SUCCESS_REDERIVE_DONE', { changed: this.$n(result.data.changed) }) })
        }
    }
}
</script>
